// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel--3Dzyi","arrowIcon":"arrowIcon--1qslk","arrowLeft":"arrowLeft--1IQ5F","arrowRight":"arrowRight--cBsw4"};